/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

module.exports = Odigeo.Widget.extend({

    init: function() {
        this.options = Odigeo.Utils.parseOptions(this.options);
        this.model.set('resultsPerPage', this.options.resultsPerPage);
        this.model.set('paginationMaxPageSet', this.options.paginationMaxPageSet);
        this.view.initPagination();
    },

    modelClass: require('../modules/models/accommodation_pagination_manager.js'),

    viewClass: require('../modules/views/accommodation_pagination_manager.js'),

    updatePagination: function(data, resetPagination = true) {
        this.model.updatePage(resetPagination);
        this.model.updateModel(data);
    },

    clear: function() {
        this.model.clearModel();
    },

    toFirstPage: function() {
        this.view.loadSelectedPage.call(this.view, 1);
    },

    showContainer: function() {
        this.view.showContainer();
    },

    hideContainer: function() {
        this.view.hideContainer();
    },
});
